import { DefaultExposeGroupEnum } from '@goparrot/common';
var PromotionUsageCustomExposeGroup;
(function (PromotionUsageCustomExposeGroup) {
})(PromotionUsageCustomExposeGroup || (PromotionUsageCustomExposeGroup = {}));
export const PromotionUsageExposeGroup = Object.freeze({
    ...DefaultExposeGroupEnum,
    ...PromotionUsageCustomExposeGroup,
});
//# sourceMappingURL=PromotionUsageExposeGroup.js.map